module.exports = __webpack_public_path__ + "static/media/excel.6f9a8684.svg";